import { TFunction } from "i18next";
import * as Yup from "yup";
import { Option } from "../../Products/types";
import { UnitProxy } from "@me-team/host/main/graphql/types";
import { WarehouseTutorialType } from "../../../utils/enums";
import { ALT_UNIT_GROUP_NONE_ID, transformToNullableNumber } from "../../Products/constants";

export const productFormValidationSchema = (t: TFunction, productExist?: boolean) => {
    return Yup.object().shape({
        quantity: Yup.number().required(t("validation.required")),
        unit: Yup.number().moreThan(0, t("Numeric value, must be greater than 0")).required(t("validation.required")),
        ...(productExist
            ? {}
            : {
                  category: Yup.number().required(t("validation.required")),
                  name: Yup.string().trim().required(t("validation.required")),
                  brand: Yup.string().trim().required(t("validation.required")),
                  sku: Yup.string().trim(),
                  barcode: Yup.string().trim(),
                  unitGroup: Yup.number().required(t("validation.required")),
                  unit: Yup.number().required(t("validation.required")),
                  price: Yup.number().required(t("validation.required")),
                  unitForSale: Yup.number().required(t("validation.required")),
                  alternativeUnitGroupInput: Yup.object().shape({
                      alternativeUnitGroup: Yup.number()
                          .test("required-or-none", t("validation.required"), (val) => {
                              if (val === null || val === undefined) return false;
                              return val === ALT_UNIT_GROUP_NONE_ID || (typeof val === "number" && val > 0);
                          })
                          .required(t("validation.required")),
                      alternativeValue: Yup.number()
                          .transform(transformToNullableNumber)
                          .nullable()
                          .when("alternativeUnitGroup", {
                              is: (groupId: number | null) => groupId === ALT_UNIT_GROUP_NONE_ID,
                              then: (schema) => schema.notRequired().nullable(),
                              otherwise: (schema) =>
                                  schema.typeError(t("validation.required")).required(t("validation.required")),
                          }),
                      alternativeUnit: Yup.number()
                          .transform(transformToNullableNumber)
                          .nullable()
                          .when("alternativeUnitGroup", {
                              is: (groupId: number | null) => groupId === ALT_UNIT_GROUP_NONE_ID,
                              then: (schema) => schema.notRequired().nullable(),
                              otherwise: (schema) =>
                                  schema.typeError(t("validation.required")).required(t("validation.required")),
                          }),
                  }),
              }),
    });
};

export const getCombinedUnitOptions = (
    unitForSale: number | null,
    unitOptions: Option[],
    relationsAlternativeUnits: UnitProxy[] | null
): Option[] => {
    const options: Option[] = [];

    if (unitForSale) {
        const unitForSaleOption = unitOptions.find((opt) => opt.value === unitForSale);
        if (unitForSaleOption) {
            options.push(unitForSaleOption);
        }
    }

    if (relationsAlternativeUnits?.length) {
        relationsAlternativeUnits.forEach((unit) => {
            options.push({
                value: unit.id,
                label: unit.name,
            });
        });
    }

    return options;
};

export const getItemsPerPageValue = (
    tutorialActive: boolean,
    createdProductId: string | null,
    tutorialType: WarehouseTutorialType,
    currentStep: number,
    rightStep: number = 5
) =>
    tutorialActive &&
    createdProductId &&
    [WarehouseTutorialType.WAREHOUSE_PRODUCT_MOVEMENT, WarehouseTutorialType.PRODUCT_SALES].includes(tutorialType) &&
    currentStep === rightStep
        ? 10000
        : 20;
